import React, { useState } from 'react';
import _ from "lodash";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";

import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { EmptyData } from "../../../../../components/empty/emptyData";
import { PageHeader } from "../../../../../components/page-header";
import { ContentPartFilter } from "../../../../../components/content-part/ContentPartFilter";
import { useTypesOfPesticides } from "./useTypesOfPesticides";
import { AddTypesOfPesticides } from "./AddTypesOfPesticides";
import {
  useLazyGetTypesOfPesticidesQuery
} from "../../../../../redux/api/handBooksApi/chemicalization/typesOfPesticides";
import { BasicHbFilter } from "../../../../../models/filters/basicHbFilter";
import { EntDirectoryInfoName } from "../../../../../models/directoryInfoName";
import { FilterByNameHB } from "../../../../../components/filterByNameHB/FilterByNameHB";


enum FormField {
  name
}

export const TypesOfPesticides = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntDirectoryInfoName>(new EntDirectoryInfoName());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()
  const {
	onAddTypesOfPesticides,
	onDeleteTypesOfPesticides,
	onEditTypesOfPesticides
  } = useTypesOfPesticides(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const [getArchiveFolders] = useLazyGetTypesOfPesticidesQuery();

  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntDirectoryInfoName, BasicHbFilter>({
	initialFilter: new BasicHbFilter(),
	query: getArchiveFolders
  });
  const openAddModal = (item: EntDirectoryInfoName) => {
	setSelectedItem(item);
	setShowModal(true);
  };
  const setEntityFromFields = (): BasicHbFilter => {
	let filt: BasicHbFilter = _.clone(filter);
	filt.name = form.getFieldValue(FormField.name) ?? null;
	filt.page = 1;
	return filt;
  }
  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 7 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		) : null }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item?.nameKy }</td>
			<td>{ item?.nameRu }</td>

			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteTypesOfPesticides(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : (
		  <tr>
			<td colSpan={ 9 }>
			  <EmptyData/>
			</td>
		  </tr>
		) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('titles.types_of_pesticides') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('handbooks.types_of_pesticides.types_of_pesticides_desc') } { t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntDirectoryInfoName())
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterByNameHB
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } }
		  formField={ FormField }
		  form={ form }
		/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddTypesOfPesticides
		typesOfPesticides={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== 0 ? onEditTypesOfPesticides : onAddTypesOfPesticides }
	  />
	  { contextHolder }
	</>
  );
}
